module.exports = __webpack_public_path__ + "images/20cc8a1aaf32527e3e49695fa937a70c.jpg";